import React from "react";

import { StickyNote } from "lucide-react";

import { FLOW } from "./flowCopy";
import { shortDate } from "./shared";
import type { PlanFile } from "../../Types/AccountPlan";

interface Props {
  file?: PlanFile | null;
  className?: string;
}

/**
 * The AE's note on the plan, written when they confirmed it (2026-10-31).
 * Shown with the version wherever it is read or reviewed; nothing when the
 * AE confirmed without one.
 */
const ConfirmNote: React.FC<Props> = ({ file, className = "" }) => {
  const note = file?.confirm_note?.trim();
  if (!note) return null;
  return (
    <div
      data-testid="confirm-note"
      className={`flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50/60 px-3 py-2 text-sm ${className}`}
    >
      <StickyNote
        className="mt-0.5 h-4 w-4 shrink-0 text-amber-600"
        aria-hidden
      />
      <div className="min-w-0">
        <div className="text-xs font-semibold text-amber-900">
          {FLOW.confirmNoteHeading}
          {file?.confirmed_by_name ? ` · ${file.confirmed_by_name}` : ""}
          {file?.confirmed_at ? ` · ${shortDate(file.confirmed_at)}` : ""}
        </div>
        <p className="whitespace-pre-line break-words text-gray-800">{note}</p>
      </div>
    </div>
  );
};

export default ConfirmNote;
